import ImportsListPage from 'containers/ImportsList'

export default ImportsListPage
